<template>
	<img src='./google-colored.png' width = '24px' height = '24px'>
</template>

<script>
	export default {
		name: 'GoogleIcon'
	}
</script>